// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__A+o3K","rotation":"SmallLoader_rotation__rzTJN"};